import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { setLoyaltyLocation } from '@tcp/core/src/constants/analytics';
import { getWishListTrackingObj } from '@tcp/core/src/utils/utils.web';
import { FavoritesIcons } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductItemComponents.jsx';
import { AddToWishListButton } from './styles/PriceAndWishList.style';
import { getWishListData } from './plpTileHelpers/priceAndWishlistHelper';

import { getProductBrandTitle } from './plpTileHelpers/plpTileCommonHelpers';

import { ProductBrand, ProductTitle, ExtendedSizes } from './styles/ProductTitle.style';
import PlpTileAnchor from './PlpTileAnchor';
import plpTileLocators from './plpTileLocators';

const checkIsFavorite = (isFavorite) => {
  return isFavorite;
};

const renderBundleExtendedSizeCopy = ({
  isMountedTileRedesignAB,
  isBundle,
  extendedSizes,
  isPjpTile,
}) => {
  return isMountedTileRedesignAB && isBundle && !isPjpTile && extendedSizes ? (
    <ExtendedSizes
      fontFamily="secondary"
      fontSize={['fs10', 'fs10', 'fs12']}
      fontWeight="extrabold"
    >
      {extendedSizes}
    </ExtendedSizes>
  ) : null;
};

const getPageName = (isSLPTile) => (isSLPTile ? 'SLP' : 'PLP');

const ProductTitleAndBrand = (props) => {
  const {
    productName: productTitle,
    brand,
    pdpUrl,
    trackWishListClick,
    itemAvailability,
    onAddItemToFavorites,
    onSetLastDeletedItemIdAction,
    isLoggedIn,
    isPjpTile,
    primaryBrand,
    productPartNo,
    wishListData,
    pathName,
    setProductDataForPdp,
    productName,
    isBundle,
    setPLPSLPAddToCartCTA,
    isNewFavIcon,
    isTileRedesignAB,
    extendedSizes,
    isMountedTileRedesignAB,
    isSLPTile,
  } = props;

  const { isFavorite, wishList } = useMemo(
    () =>
      getWishListData({
        productPartNo,
        wishListData,
        primaryBrand,
      }),
    [productPartNo, wishListData, primaryBrand]
  );
  const addOrRemoveItemToFavorites = () => {
    const loyaltyLocation = `favorites| ${getPageName(isSLPTile)}}`;
    setLoyaltyLocation(loyaltyLocation);
    const wishListObj = getWishListTrackingObj(loyaltyLocation, isLoggedIn);
    trackWishListClick(wishListObj);
    if (!isFavorite) {
      onAddItemToFavorites({
        colorProductId: productPartNo,
        page: getPageName(isSLPTile),
        products: null,
      });
    } else {
      onSetLastDeletedItemIdAction({
        externalId: wishList?.id,
        productId: productPartNo,
        itemId: wishList.itemId,
        notFromFavoritePage: true,
        wishListName: wishList?.displayName,
      });
    }
  };
  const { brandTitle } = getProductBrandTitle(brand, primaryBrand);
  return (
    <>
      {itemAvailability?.isSoldOut ? (
        <div className="flex-row justify-between">
          <div>
            {brandTitle && (
              <ProductBrand data-locator={plpTileLocators.productBrand}>{brandTitle}</ProductBrand>
            )}
            {renderBundleExtendedSizeCopy({
              isMountedTileRedesignAB,
              isBundle,
              extendedSizes,
              isPjpTile,
            })}
            {productTitle && (
              <ProductTitle
                data-locator={plpTileLocators.productTitle}
                isTileRedesignAB={isTileRedesignAB}
              >
                {productTitle}
              </ProductTitle>
            )}
          </div>
          {!isBundle && isPjpTile && setPLPSLPAddToCartCTA === 'off' && !isNewFavIcon ? (
            <AddToWishListButton
              aria-pressed={checkIsFavorite(isFavorite)}
              aria-label={`Add To Favorite ${productName}`}
              onClick={addOrRemoveItemToFavorites}
              data-locator={plpTileLocators.addToFavoritetn}
            >
              <FavoritesIcons isSolidIcon={isFavorite} />
            </AddToWishListButton>
          ) : null}
        </div>
      ) : (
        <div className="flex-row justify-between">
          <div>
            <PlpTileAnchor
              pathName={pathName}
              pdpUrl={pdpUrl}
              title={productTitle}
              setProductDataForPdp={setProductDataForPdp}
              isSLPTile={isSLPTile}
            >
              {brandTitle && (
                <ProductBrand data-locator={plpTileLocators.productBrand}>
                  {brandTitle}
                </ProductBrand>
              )}
              {renderBundleExtendedSizeCopy({
                isMountedTileRedesignAB,
                isBundle,
                extendedSizes,
                isPjpTile,
              })}
              {productTitle && (
                <ProductTitle
                  data-locator={plpTileLocators.productTitle}
                  isTileRedesignAB={isTileRedesignAB}
                  isPjpTile={isPjpTile}
                >
                  {productTitle}
                </ProductTitle>
              )}
            </PlpTileAnchor>
          </div>
          {!isBundle && isPjpTile && setPLPSLPAddToCartCTA === 'off' && !isNewFavIcon ? (
            <AddToWishListButton
              aria-pressed={checkIsFavorite(isFavorite)}
              aria-label={`Add To Favorite ${productName}`}
              onClick={addOrRemoveItemToFavorites}
              data-locator={plpTileLocators.addToFavoritetn}
            >
              <FavoritesIcons isSolidIcon={isFavorite} />
            </AddToWishListButton>
          ) : null}
        </div>
      )}
    </>
  );
};
ProductTitleAndBrand.propTypes = {
  productName: PropTypes.string,
  pdpUrl: PropTypes.shape({
    asPath: PropTypes.string,
    href: PropTypes.string,
    asPathWithoutSlug: PropTypes.string,
  }),
  brand: PropTypes.string.isRequired,
  primaryBrand: PropTypes.string.isRequired,
  itemAvailability: PropTypes.shape({
    isSoldOut: PropTypes.bool,
  }),
  isSLPTile: PropTypes.bool,
};
ProductTitleAndBrand.defaultProps = {
  productName: '',
  pdpUrl: {},
  itemAvailability: {
    isSoldOut: false,
  },
  isSLPTile: false,
};
export default ProductTitleAndBrand;
